

import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import * as _ from 'lodash';

@Component({
  selector: 'app-radios-property',
  templateUrl: './radios-property.component.html',
  styleUrls: ['./radios-property.component.scss']
})
export class RadiosPropertyComponent implements OnInit {
  private _attributes: any;
  public varcharAttributes: Array<any> = [];

  @Input() component: any;
  @Input() set attributes(value: any) {
    this._attributes = value;

    if (this._attributes) {
      this.varcharAttributes = _.sortBy(
        this._attributes.filter((att: any) => {
          return att.type === 'varchar';
        }),
        ['name']
      );
    }
  }

  get attributes(): any {
    return this._attributes;
  }

  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    // if (this.component && this.component.element) {
    //   this.component.element.field_name = 'radio_buttons_label';
    // }
  }

  setAsDefault($event: any) {
    this.component.element.options.forEach((v: any, k: number) => {
      if (v.id == $event.target.value) {
        v.is_selected = true;
      } else {
        v.is_selected = false;
      }
    });
  }

  addOption() {
    this.component.element.options.push({
      id: UUID.UUID(),
      text: this.translate.instant('Option') + ' ' + (this.component.element.options.length + 1),
      value: this.translate.instant('Value') + ' ' + (this.component.element.options.length + 1),
      is_selected: false
    });
  }

  removeOption(optionId: any) {
    this.component.element.options = this.component.element.options.filter((v: any) => {
      return v.id != optionId;
    });
  }

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({
      value: $event,
      id: this.component.id
    });
  }

  onLabelChange(label: string) {
    // Update field name: convert to lowercase, replace spaces/special chars with underscores
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
          .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
          .replace(/_+/g, '_')           // Replace multiple underscores with single
          .substring(0, 100)             // Limit to 100 characters
      : '';
  }

    // Call this method when the text of an option changes to auto-update its value
  onOptionTextChange(option: any) {
    if (option && typeof option.text === 'string') {
      option.value = option.text
        ? option.text.toLowerCase()
            .replace(/[^a-z0-9]+/g, '_')  // Replace non-alphanumeric chars with underscore
            .replace(/^_+|_+$/g, '')       // Remove leading/trailing underscores
            .replace(/_+/g, '_')           // Replace multiple underscores with single
            .substring(0, 100)             // Limit to 100 characters
        : '';
    }
  }

    // Remove forbidden special characters from field_name (SQL Server safe)
  sanitizeFieldName() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      // Only allow letters, numbers, and underscores, must start with letter or underscore
      let val = this.component.element.field_name;
      // Remove forbidden special characters ($&^#@ and others)
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      // Limit to 100 chars
      this.component.element.field_name = val.substring(0, 100);
    }
  }

    // Prevent forbidden special characters from being entered
  preventSpecialChar(event: KeyboardEvent) {
    const allowed = /^[A-Za-z0-9_]$/;
    // Allow navigation, backspace, delete, tab, arrows, home, end
    if (
      event.ctrlKey || event.metaKey ||
      [8, 9, 13, 16, 17, 18, 20, 27, 35, 36, 37, 38, 39, 40, 46].includes(event.keyCode)
    ) {
      return;
    }
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }

  // Filter forbidden characters on paste or input
  filterSpecialCharOnInput() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      let val = this.component.element.field_name;
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      this.component.element.field_name = val.substring(0, 100);
    }
  }
}
